<template>
	<right-panel :datas="connects" ref="rightPanel" @onClose="onClose">
		<div slot="header">
			<translate>Manage Code</translate>
		</div>
		<div slot="content" class="manage-code">
			<el-table :data="m" style="width: 100%" v-loading="loading">
				<el-table-column :label="attrText.member">
					<template scope="scope">
						<img class="account-photo" :src="scope.row.account.avatar | resetURL" />
						<span>{{ scope.row.account.name }}</span>
					</template>
				</el-table-column>
				<el-table-column label="Code">
					<template scope="scope">
						<span v-if="scope.row.type === 'tmp_share'">{{ attrText.temporary }}</span>
						<span v-else-if="$store.getters.account.id == scope.row.account.id">{{ scope.row.code }}</span>
						<span v-else>{{ hideStr(scope.row.code) }}</span>
					</template>
				</el-table-column>
				<el-table-column :label="attrText.allowIP">
					<template scope="scope" v-if="scope.row.allow_ip">
						<div v-for="(ip, ipIndex) in getAllowIPList(scope.row.allow_ip)" :key="ipIndex" class="ip-space">{{ ip }}</div>
					</template>
				</el-table-column>
				<el-table-column width="120" :label="attrText.startEndTime">
					<template scope="scope">
						<div style="white-space: normal">
							{{ (scope.row.create_time * 1000) | moment('YYYY-MM-DD HH:mm:ss') }}
						</div>
						<div style="white-space: normal" :class="scope.row.expire_time < newTime ? 'over-time' : ''">
							{{ (scope.row.expire_time * 1000) | moment('YYYY-MM-DD HH:mm:ss') }}
						</div>
					</template>
				</el-table-column>
				<el-table-column :label="attrText.action">
					<template scope="scope">
						<div>
							<el-button type="text" v-if="scope.row.type !== 'tmp_share'" @click.stop="modifyCode(scope.row)"><translate>Change</translate></el-button>
						</div>
						<el-button type="text" @click.stop="deleteCode(scope.row)" :loading="scope.row.saving"><translate>Delete</translate></el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div slot="footer" v-if="connects">
			<el-button type="primary" @click="showCreateModal" :disabled="!canCreateStatus || connects.agent_status !== 1"><translate>Create</translate></el-button>
			<el-button v-if="connects.resource_type === 'ecs'" :disabled="connects.agent_status !== 1" type="primary" @click="showTempModal"><translate>Temporary Authorize</translate></el-button>
		</div>
	</right-panel>
</template>
<script>
import { Utils } from '../../../config'
import STORE_CONST from '../../../store/consts'
import RightPanel from '../../common/right-panel'
import Utility from '../../../Utils'

export default {
	name: 'ManageCode',
	props: {
		items: {
			required: true,
		},
	},
	data() {
		return {
			connects: null,
			m: null,
			canCreateStatus: false,
			currentAccountId: this.$store.getters.account.id,
			newTime: Math.ceil(new Date().getTime() / 1000),
			loading: true,
		}
	},
	computed: {
		attrText() {
			return this.getTranslateText()
		},
	},
	mounted() {},
	created() {},
	methods: {
		getAllowIPList(allowIP) {
			if (!allowIP) {
				return []
			}
			const legacyIPv4ListPattern = /^(\d{1,3}\.){3}\d{1,3}(:(\d{1,3}\.){3}\d{1,3})+$/
			let result = []
			allowIP.split(';').forEach((section) => {
				section = section.trim()
				if (legacyIPv4ListPattern.test(section)) {
					result = result.concat(section.split(':'))
				} else if (section) {
					result.push(section)
				}
			})
			return result
		},
		getTranslateText() {
			return {
				member: this.$gettext('Member'),
				action: this.$gettext('Action'),
				allowIP: this.$gettext('Allow IP'),
				startEndTime: this.$gettext('Create Time / Expire Time'),
				temporary: this.$gettext('Temporary Authorize'),
			}
		},
		onClose() {
			this.$emit('onClosePanel')
			this.$emit('reloadTunnelCode', [this.connects.project_resource_id])
			// && connects.agentVersion<'2.4.0'
			this.connects = null
		},
		showCreateModal() {
			this.$emit('onShowModal', { name: 'showCreateModal' })
		},
		showTempModal() {
			this.$emit('onShowModal', { name: 'showTempModal' })
		},
		canCreate() {
			this.canCreateStatus = true
			this.m.forEach((item) => {
				if (item.account.id === this.currentAccountId && item.type !== 'tmp_share') {
					this.canCreateStatus = false
				}
			})
		},
		getTunelInfo(id) {
			const params = {
				results_per_page: Utils.config.maxPageSize,
				q: {
					filters: [
						{
							name: 'project_resource_id',
							op: 'eq',
							val: id,
						},
						{
							name: 'status',
							op: 'eq',
							val: 'enable',
						},
					],
					order_by: [
						{
							field: 'create_time',
							direction: 'desc',
						},
					],
				},
			}
			this.$store.dispatch(STORE_CONST.WORKGROUP.GET_TUNNEL_CODE, params).then(
				(res) => {
					this.loading = false
					let data = res.objects
					let list = []
					if (data.length > 0) {
						data.forEach((item) => {
							if (item.allow_ip) {
								item.allowIPList = this.getAllowIPList(item.allow_ip)
							}
							list.push(item)
						})
					}
					this.m = list
					this.canCreate()
				},
				() => {
					this.loading = false
				}
			)
		},
		modifyCode(row) {
			this.$emit('onShowModal', { name: 'modifyCreateModal', code: row.code })
		},
		deleteCode(row) {
			row.saving = true
			this.$confirm(this.$gettext('Are you sure to delete code ') + '  ' + this.hideStr(row.code) + '?', this.$gettext('Delete code confirm'), {
				confirmButtonText: this.$gettext('OK'),
				cancelButtonText: this.$gettext('Cancel'),
				type: 'warning',
			}).then((event) => {
				this.$store.dispatch(STORE_CONST.WORKGROUP.DELETE_CODE, row.code).then((res) => {
					this.m.remove(row)
					this.$notify({
						type: 'success',
						message: this.$gettext('Delete successfully'),
					})
				})
			})
		},
		hideStr(str) {
			return Utility.Utils.hideStr(str)
		},
	},
	watch: {
		items: {
			handler: function (newVal) {
				if (this.connects) {
					this.connects = null
					setTimeout(() => {
						this.connects = this.items
						this.getTunelInfo(this.connects.project_resource_id)
					}, 300)
				} else {
					this.connects = this.items
					this.getTunelInfo(this.connects.project_resource_id)
				}
			},
			deep: true,
		},
	},
	components: {
		RightPanel,
	},
}
</script>
<style lang="scss" rel="stylesheet/scss">
@import '../../../assets/css/variable';
.manage-code {
	.over-time {
		color: red;
	}
	.ip-space {
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
	}
}
</style>



// WEBPACK FOOTER //
// manage-code.vue?b19d0080